export const VoucherResourcesEn = {
  ggcTitle: "You have received goodie eGift card for {amount} PLN.",
  ggcDescription: "To use the card open goodie mobile app or if you don't have it you will be asked to install it.",

  cshbTitle: "Your code includes {amount} PLN bonus cashback.",
  cshbDescription: "To claim your bonus, go to the Cashback section, shop with goodie, and enjoy your bonus.",

  mobileDescription: "To use the card claim and activate it.",

  cbButtonText: "Move to cashback",

  faqTitle: "FAQ",

  activationTimeDescription: "Activate the code in goodie app before {date}",
};
